module.exports = __webpack_public_path__ + "img/007-dialog.99bf38e7.png";